<template>
    <div class="tw-flex tw-overflow-x-auto tw-no-scrollbar">
        <div class="tw-flex tw-flex-nowrap tw-gap-[7px] md:tw-gap-[10px] tw-text-sm">
            <MuButton v-if="isMultipleTabs" v-for="(option, i) in tabOptions" :key="i" @click="onTabClick(option)"
                variant="custom"
                class="tw-whitespace-nowrap tw-flex tw-items-center tw-justify-center tw-text-center tw-border tw-text-[#000C17] dark:tw-text-white dark:tw-border-[#445F74] tw-px-4 lg:tw-px-6 tw-mb-0 tw-leading-[1px] tw-text-[13px] sm:tw-text-sm md:tw-text-base"
                :class="isActive(option.value) ? `tw-bg-[#28282D] dark:tw-bg-[#445F74] tw-text-white` : `hover:tw-bg-[#E7E7E8] hover:dark:tw-bg-[#223F57] hover:dark:tw-text-white tw-bg-white dark:tw-bg-[#000C17] tw-border-[#CBCBCD] dark:tw-text-white`">
                {{ option.value }}
            </MuButton>
            <div v-else v-for="(option, i) in tabOptions" class="tw-text-xl md:tw-text-2xl tw-font-bold tw-text-[#000C17] dark:tw-text-white tw-capitalize">
                {{ option.value }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import {useCollectionStore} from "@stores/collection";
import {storeToRefs} from "pinia/dist/pinia";
import MuButton from '@units/Button/MuButton';

const collectionStore = useCollectionStore();
const { loading: collectionStoreLoading } = storeToRefs(collectionStore);

const props = defineProps({
    tabOptions: {
        type: Array,
        default: [],
    },
    activeTab: {
        type: String,
        default: '',
    },
});
const emit = defineEmits(['onTabClick']);

const isActive = (value) => {
    return value === props.activeTab;
};

const onTabClick = (tab) => {
    !collectionStoreLoading.value && emit('onTabClick', tab);
};

const isMultipleTabs = computed(() => {
    return props.tabOptions.length > 1;
});
</script>
